module.exports = __webpack_public_path__ + "static/media/file-check.c21954c8.svg";